export default {
  methods: {
    bgCover (icon, type = 'avatar', mode = 'cover') {
      this.index = this.index || 1
      if (!icon) {
        icon = require('@spero/spero-utils/src/assets/imgs/avatar.png')
      }
      if (type === 'avatar') {
        return {
          background: `url('${icon}${icon.indexOf('?') === -1 ? '?' : '&'}x-oss-process=image/resize,h_200,w_200/format,jpg/quality,Q_80') center/${mode} no-repeat`
        }
      } else if (type === 'unchange') {
        return {
          background: `url('${icon}') center/${mode} no-repeat`
        }
      } else {
        return {
          background: `url('${icon}${icon.indexOf('?') === -1 ? '?' : '&'}x-oss-process=image/quality,Q_80') center/${mode} no-repeat`
        }
      }
    }
  }
}
